import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      d="M91.5 100.66c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4"
    />
    <path fill="#0597A3" d="M84.34 16.26a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#00D8D8"
      d="M6.57 62.37a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M71.76 102.8l3.94-3.94c.59-.59.59-1.54 0-2.12s-1.54-.59-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0c-.58.59-.59 1.54 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM111.07 17.34h-5.57v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M25.99 30h64.03c3.31 0 5.99 2.7 5.99 6.04v43.93c0 3.33-2.68 6.04-5.99 6.04H25.99c-3.31 0-5.99-2.7-5.99-6.04V36.04c0-3.33 2.68-6.04 5.99-6.04"
    />
    <path
      fill="#0597A3"
      d="M28.91 34h58.18C89.8 34 92 36.21 92 38.95v38.11c0 2.73-2.2 4.95-4.91 4.95H28.91c-2.71 0-4.91-2.21-4.91-4.95V38.95c0-2.73 2.2-4.95 4.91-4.95"
    />
    <path
      fill="#00D8D8"
      d="M50 45.22v15.56c0 1.75 1.88 2.81 3.32 1.86l11.7-7.75c1.31-.87 1.32-2.85 0-3.72l-11.7-7.81c-1.43-.96-3.32.1-3.32 1.86M84 76.25H32c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h52c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25"
    />
    <path
      fill="#001A43"
      d="M56 76.25H32c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h24c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25"
    />
  </svg>
);
const SvgEnrichedIconVideoInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconVideoInverted);
export default Memo;
